<template>
  <v-container>
    <h1 class="mt-10 mb-10">{{ $t('nav.services') }}</h1>
    <p><span class="bold-text" style="color:#01579B;">Shanghai Shunda CPA Co., Ltd.</span> offers a comprehensive suite
      of services designed to help your business thrive.
    </p>
    <p>Our expertise spans four key areas:</p>
    <br />
    <v-row no-gutters>
      <v-col>
        <div class="item-image" style="background-image: url(/assets/img/GGI4.1_gnrztegnrztegnrz.png)"></div>
      </v-col>
      <v-col>
        <div class="item-body" style="padding-left: 60px; padding-top: 10px;">
          <h2>Audit Services</h2>
          <ul class="list-marked text-gray-800">
            <li>
              <span class="bold-text">Financial Statement Audits: </span>
              <p>Ensure the accuracy and reliability of your financial statements.</p>
            </li>
            <li><span class="bold-text">Liquidation Accounting: </span>
              <p>Facilitate smooth corporate liquidations.</p>
            </li>
            <li><span class="bold-text">Internal Control Audits: </span>
              <p>Strengthen your internal controls and mitigate risks.</p>
            </li>
            <li><span class="bold-text">Special Purpose Audits: </span>
              <p>Address specific needs, such as capital verification, asset appraisals, and
                high-tech audits.</p>
            </li>
          </ul>
        </div>
      </v-col>
    </v-row>
    <v-row no-gutters>
      <v-col>
        <div class="item-body" style="padding-right: 30px;">
          <h2>Tax Services</h2>
          <ul class="list-marked text-gray-800">
            <li><span class="bold-text">Transfer Pricing: </span>
              <p>Optimize your transfer pricing strategies and minimize tax risks.</p>
            </li>
            <li><span class="bold-text">M&A Tax: </span>
              <p>Navigate complex tax issues related to mergers, acquisitions, and restructuring.</p>
            </li>
            <li><span class="bold-text">Corporate and Individual Income Tax: </span>
              <p>Ensure compliance with tax regulations and optimize tax liabilities.</p>
            </li>
            <li><span class="bold-text">R&D Tax Incentives: </span>
              <p>Maximize tax benefits for research and development activities.</p>
            </li>
          </ul>
        </div>
      </v-col>
      <v-col>
        <div class="item-image" style="background-image: url(/assets/img/GGI4.2_9swc6r9swc6r9swc.png)"></div>
      </v-col>
    </v-row>
    <v-row no-gutters>
      <v-col>
        <div class="item-image" style="background-image: url(/assets/img/GGI4.3_ey2mzgey2mzgey2m.png)"></div>
      </v-col>
      <v-col>
        <div class="item-body" style="padding-left: 60px;">
          <h2>Accounting Services</h2>
          <ul class="list-marked text-gray-800">
            <li><span class="bold-text">Financial Process Design: </span>
              <p>Establish efficient and effective financial processes.</p>
            </li>
            <li><span class="bold-text">Accounting and Reporting: </span>
              <p>Maintain accurate financial records and generate timely reports.</p>
            </li>
            <li><span class="bold-text">Payroll and Tax: </span>
              <p>Manage payroll, calculate taxes, and ensure compliance with labor laws.</p>
            </li>
            <li><span class="bold-text">Expatriate Tax Services: </span>
              <p>Assist foreign employees with tax compliance and optimization.</p>
            </li>
          </ul>
        </div>
      </v-col>
    </v-row>
    <v-row no-gutters>
      <v-col>
        <div class="item-body" style="padding-right: 30px;">
          <h2>Consulting Services</h2>
          <ul class="list-marked  text-gray-800">
            <li><span class="bold-text">Financial Consulting: </span>
              <p>Provide strategic financial advice to support business growth.</p>
            </li>
            <li><span class="bold-text">IPO Planning: </span>
              <p>Guide you through the IPO process and help you meet regulatory requirements.</p>
            </li>
            <li><span class="bold-text">Due Diligence: </span>
              <p>Conduct thorough financial investigations for mergers, acquisitions, and investments.</p>
            </li>
            <li><span class="bold-text">Dispute Resolution: </span>
              <p>Assist in resolving complex economic disputes.</p>
            </li>
          </ul>
        </div>
      </v-col>
      <v-col>
        <div class="item-image" style="background-image: url(/assets/img/GGI4.4_fevgy2fevgy2fevg.png)"></div>
      </v-col>
    </v-row>
  </v-container>
</template>

<script setup>
</script>

<style scoped>
.item-image {
  width: 100%;
  height: 100%;
  flex-shrink: 0;
  min-height: 180px;
  background-size: cover;
  background-position: center;
}

.item-body {
  width: 100%;
  padding-top: 30px;
  padding-bottom: 40px;
}

.item-body>p {
  font-size: 16px;
  line-height: 1.5;
  margin-top: 16px;
}

.item-body>h2 {
  color: #01579B;
}

.bold-text {
  font-weight: bold;
}

.list-marked-big {
  padding-left: 24px;
  margin-top: 16px;
  font-size: 18px;
  line-height: 1.35;
}

.list-marked-big>li {
  padding-left: 12px;
  margin-top: 12px;
}

.list-marked {
  text-align: left;
  font-weight: 300;
  font-size: 16px;
  margin-top: 16px;
  padding-left: 16px;
}

.list-marked>li {
  position: relative;
  padding-left: 10px;
  margin-top: 3px;
}


.text-gray-800 {
  color: #333;
}

.text-body-color {
  color: gray;
}
</style>